import './theme/fonts';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './i18n';
import { applyCachedThemeOnBoot } from './theme/themeCache';

applyCachedThemeOnBoot();

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element #root not found');
}

const root = ReactDOM.createRoot(container);
root.render(
  <React.Suspense fallback="loading...">
    <App />
  </React.Suspense>,
);
